module.exports = __webpack_public_path__ + "img/icon-title.a048628f.png";